import { colors } from './constants/colors';

/**
 * Box Shadow Design Tokens & Styled-Components Mixins
 *
 * Base shadow colour: #102C55 (Blue7 / primary-blue-07) at varying opacities.
 *
 * Every variant is composed of the **base** layer plus its own layer so there
 * is a consistent subtle lift underneath every shadow size.
 *
 * Usage with styled-components:
 *   import { shadowMixin } from '../../styled/theme/shadows';
 *
 *   const Card = styled.div`
 *     ${shadowMixin.M}
 *   `;
 */

// ---------------------------------------------------------------------------
// Raw shadow values
// ---------------------------------------------------------------------------

/** Base shadow layer — always applied under every variant */
const BASE = '0px 2px 4px 0px rgba(16, 44, 85, 0.04)';

/** Individual variant layers (stacked on top of the base) */
const VARIANT_XS = '0px 2px 4px 0px rgba(16, 44, 85, 0.04)';
const VARIANT_S  = '0px 16px 32px -4px rgba(16, 44, 85, 0.10)';
const VARIANT_M  = '0px 24px 48px -12px rgba(16, 44, 85, 0.12)';
const VARIANT_L  = '0px 40px 80px -16px rgba(16, 44, 85, 0.24)';

// ---------------------------------------------------------------------------
// Composed shadow strings  (base + variant)
// ---------------------------------------------------------------------------

export const SHADOW_XS = `${BASE}, ${VARIANT_XS}`;
export const SHADOW_S  = `${BASE}, ${VARIANT_S}`;
export const SHADOW_M  = `${BASE}, ${VARIANT_M}`;
export const SHADOW_L  = `${BASE}, ${VARIANT_L}`;

// ---------------------------------------------------------------------------
// Styled-components CSS mixins
// ---------------------------------------------------------------------------

export const shadowMixin = {
    XS: `box-shadow: ${SHADOW_XS};`,
    S:  `box-shadow: ${SHADOW_S};`,
    M:  `box-shadow: ${SHADOW_M};`,
    L:  `box-shadow: ${SHADOW_L};`,
};

// ---------------------------------------------------------------------------
// Modal-specific tokens
// ---------------------------------------------------------------------------

/** All modals should use the L shadow variant */
export const MODAL_SHADOW = SHADOW_L;
export const modalShadowMixin = shadowMixin.L;

/**
 * Modal overlay (backdrop) background.
 * Spec: primary-blue/07 (#102C55) at 12 % opacity.
 */
export const MODAL_OVERLAY_BG = `${colors.Blue7}1F`;
export const modalOverlayMixin = `background: ${MODAL_OVERLAY_BG};`;
